import React from 'react';

import { classes } from './LockedIcon.st.css';

export const LockedIcon: React.FC = () => {
  return (
    <div className={classes.root}>
      <span className={classes.rootCircle}></span>
    </div>
  );
};
